// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-new-article {
  padding: 4px;
}

.kb-new-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.kb-new-header h4 {
  margin: 0;
  font-weight: 700;
}

.kb-new-actions {
  display: flex;
  gap: 8px;
}

.kb-new-form {
  margin-bottom: 16px;
}

.kb-new-row {
  display: flex;
  gap: 16px;
}

.kb-new-field {
  flex: 1;
}

.kb-new-field-sm {
  max-width: 200px;
}

.kb-new-field label {
  font-weight: 600;
  font-size: 0.85em;
  margin-bottom: 4px;
  display: block;
}

.kb-editor-split {
  display: flex;
  gap: 16px;
}

.kb-editor-pane {
  flex: 1;
  min-width: 0;
}

.kb-editor-pane label {
  font-weight: 600;
  font-size: 0.85em;
  margin-bottom: 4px;
  display: block;
}

.kb-textarea {
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  resize: vertical;
  min-height: 500px;
}

.kb-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  min-height: 500px;
  overflow-y: auto;
  line-height: 1.7;
}
`, "",{"version":3,"sources":["webpack://./src/app/knowledge-base-module/components/kb-article-new/kb-article-new.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".kb-new-article {\n  padding: 4px;\n}\n\n.kb-new-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.kb-new-header h4 {\n  margin: 0;\n  font-weight: 700;\n}\n\n.kb-new-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.kb-new-form {\n  margin-bottom: 16px;\n}\n\n.kb-new-row {\n  display: flex;\n  gap: 16px;\n}\n\n.kb-new-field {\n  flex: 1;\n}\n\n.kb-new-field-sm {\n  max-width: 200px;\n}\n\n.kb-new-field label {\n  font-weight: 600;\n  font-size: 0.85em;\n  margin-bottom: 4px;\n  display: block;\n}\n\n.kb-editor-split {\n  display: flex;\n  gap: 16px;\n}\n\n.kb-editor-pane {\n  flex: 1;\n  min-width: 0;\n}\n\n.kb-editor-pane label {\n  font-weight: 600;\n  font-size: 0.85em;\n  margin-bottom: 4px;\n  display: block;\n}\n\n.kb-textarea {\n  font-family: 'Courier New', monospace;\n  font-size: 0.9em;\n  resize: vertical;\n  min-height: 500px;\n}\n\n.kb-preview {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 16px;\n  min-height: 500px;\n  overflow-y: auto;\n  line-height: 1.7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
